import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Modal, Spin } from "antd";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { usePutBankActionMutation } from "../../../redux/banks/bankAPI";
import { updateOpenModalDeleteBankAction, updateBankAction } from "../../../redux/banks/bankSlice";
// COMPONENTS
import ModalDeleteItemContainer from "../../components/modal/ModalDeleteItemContainer";
import GlobalAlert2 from "../../home/GlobalAlert2";
// AUTHORIZATION
import GETJwtToken from "../../../redux/authentication/authentication";
// INTERFACES
import { RootState } from "../../../app/store";
// CONSTANTS
import { BLANK_BANK_ACTION } from "../../../constants/bank";

function BankactionsDeleteModal() {
	// LOCAL STORAGE AND VARIABLES ******************** */
	const dispatch = useDispatch();

	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { bankAction, openModalDeleteBankAction } = useSelector((state: RootState) => state.bank);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const [triggerDeleteAction, { isLoading, isSuccess, isError, error, reset: resetDeleteAction }] =
		usePutBankActionMutation();

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onClickClose = () => {
		dispatch(updateOpenModalDeleteBankAction(false));
	};

	const onClickDelete = async () => {
		const token = await GETJwtToken();
		triggerDeleteAction({
			id: bankAction.bank_id,
			token,
			body: {
				actions: [],
				actions2delete: [bankAction.message_id],
			},
		});
	};

	// ************************************************* */
	// USE EFFECT ************************************** */
	useEffect(() => {
		if (openModalDeleteBankAction) {
			resetDeleteAction();
		}
	}, [openModalDeleteBankAction]);

	useEffect(() => {
		if (isSuccess || isError) {
			onClickClose();
			dispatch(updateBankAction({ ...BLANK_BANK_ACTION }));
		}
	}, [isSuccess, isError]);
	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Modal onOk={onClickClose} closable={false} onCancel={onClickClose} open={openModalDeleteBankAction} footer={null}>
			<Spin spinning={isLoading}>
				<ModalDeleteItemContainer
					name={bankAction.button_type}
					onClickDelete={onClickDelete}
					onClickClose={onClickClose}
				/>
			</Spin>
			{/** ---------------------------------------------------- */}
			{/** GLOBAL ALERT */}
			<GlobalAlert2 isError={isError} isSuccess={isSuccess} requestType='DELETE' error={error} name='Action' />
		</Modal>
	);
}

export default BankactionsDeleteModal;
